export default "__VITE_ASSET__DY8L9l3e__"